import { Button, Modal } from 'react-bootstrap';
import { Typography } from 'Components/atoms';
import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose';
import { CANCEL } from 'Core-utils/constants/constants';
import './styles.scss';
import classNames from 'classnames';

interface TestEngagementModalProps {
    cancelButtonDisabled?: boolean;
    modalTitle: string;
    onPrimaryButtonClick: () => void;
    primaryButtonLabel: string;
    primaryButtonDisabled?: boolean;
    show: boolean;
    onClose: () => void;
    buttonVariant: 'primary' | 'danger' | 'disabled';
    modalVariant?: 'default' | 'custom';
    matchingEngagements?: string[];
    noOfUsers?: number;
    modalContent?: React.ReactNode;
}

const TestEngagementModal = ({
    buttonVariant,
    cancelButtonDisabled,
    modalVariant,
    modalTitle,
    primaryButtonLabel,
    primaryButtonDisabled,
    show,
    onClose,
    onPrimaryButtonClick,
    modalContent,
}: TestEngagementModalProps) => {
    const buttonClassName = classNames('text-uppercase text-text-black confirmation-modal__primary-button body1', {
        'bg-primary-500': buttonVariant === 'primary',
        'bg-secondary-accent-red-4': buttonVariant === 'danger',
        'bg-primary-500 opacity-50': buttonVariant === 'disabled',
    });
    const modalClassName = `custom-width-${modalVariant ?? 'default'}`;
    return (
        <Modal show={show} className="test-engagement-modal" centered dialogClassName={modalClassName} onHide={onClose}>
            <Modal.Header>
                <Modal.Title className="text-uppercase">
                    <Typography variant="subtitle4" color="text-high-emphasis">
                        {modalTitle}
                    </Typography>
                </Modal.Title>
                <AiOutlineClose className="text-text-high-emphasis confirmation-modal__icon" onClick={onClose} />
            </Modal.Header>
            <Modal.Body>
                {modalContent}
                <div className="d-flex confirmation-modal__button justify-content-center">
                    <Button
                        className="text-uppercase text-text-high-emphasis confirmation-modal__cancel-button body1 me-4"
                        disabled={cancelButtonDisabled}
                        onClick={onClose}
                    >
                        {CANCEL}
                    </Button>
                    <Button
                        className={buttonClassName}
                        disabled={primaryButtonDisabled}
                        onClick={onPrimaryButtonClick}
                        data-testid="primary-btn"
                    >
                        {primaryButtonLabel}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default TestEngagementModal;
